import { motion } from 'framer-motion';

const Footer = ({ lastUpdateDate }) => {
  const formatDate = (date) => {
    if (!date) return '';
    
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <motion.footer
      className="footer"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.3 }}
    >
      <div className="footer-container">
        <p className="footer-text">
          Última actualización: <span className="footer-date">{formatDate(lastUpdateDate)}</span>
        </p>
      </div>
    </motion.footer>
  );
};

export default Footer;

